import { c as _c } from "react/compiler-runtime";
import { useCookies } from "react-cookie";
import { getCookieOptions } from "@/app/utils/authSession";
type CookieKeys = "auth-token" | "auth-refresh";
function useSetCookieAsync() {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["auth-token", "auth-refresh"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [, setCookie, removeCookie] = useCookies(t0);
  let t1;
  if ($[1] !== setCookie) {
    t1 = (name, value) => {
      const options = getCookieOptions();
      return new Promise((resolve, reject) => {
        ;
        try {
          setCookie(name, value, options);
          resolve();
        } catch (t2) {
          const error = t2;
          reject(error);
        }
      });
    };
    $[1] = setCookie;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const setCookieAsync = t1;
  let t2;
  if ($[3] !== removeCookie) {
    t2 = name_0 => {
      const {
        path,
        domain
      } = getCookieOptions();
      return new Promise((resolve_0, reject_0) => {
        ;
        try {
          removeCookie(name_0, {
            path,
            domain
          });
          resolve_0();
        } catch (t3) {
          const error_0 = t3;
          reject_0(error_0);
        }
      });
    };
    $[3] = removeCookie;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const removeCookieAsync = t2;
  let t3;
  if ($[5] !== removeCookieAsync || $[6] !== setCookieAsync) {
    t3 = {
      setCookieAsync,
      removeCookieAsync
    };
    $[5] = removeCookieAsync;
    $[6] = setCookieAsync;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
export default useSetCookieAsync;